<template>
  <div :class="loading ? 'loading' : ''">
    <div class="section section--school-districts">
      <div
        class="school-district"
        v-for="schoolDistrict in schoolDistricts"
        :key="schoolDistrict.id"
      >
        <h2>{{ loading ? "&nbsp;" : schoolDistrict.name }}</h2>
        <table
          class="address-details"
          v-if="loading || (schoolDistrict && schoolDistrict.details)"
        >
          <tr
            v-if="
              loading || (schoolDistrict.lowGrade && schoolDistrict.highGrade)
            "
          >
            <th>Grade Range</th>
            <td v-if="loading">&nbsp;</td>
            <td v-else>
              {{ schoolDistrict.lowGrade }} to {{ schoolDistrict.highGrade }}
            </td>
          </tr>
          <tr v-if="loading || schoolDistrict.details.website">
            <th>Website</th>
            <td v-if="loading">&nbsp;</td>
            <td v-else>
              <a :href="schoolDistrict.details.website" target="_blank">
                {{ schoolDistrict.details.website }}
              </a>
            </td>
          </tr>
          <tr v-if="loading || schoolDistrict.details.phone">
            <th>Phone Number</th>
            <td v-if="loading">&nbsp;</td>
            <td v-else>
              <a
                :href="`tel:+1${schoolDistrict.details.phone.replace(
                  /\D/g,
                  ''
                )}`"
                >{{ schoolDistrict.details.phone }}</a
              >
            </td>
          </tr>
          <tr v-if="loading || schoolDistrict.details.address">
            <th>Address</th>
            <td v-if="loading">&nbsp;<br />&nbsp;</td>
            <td v-else>
              <a
                :href="`https://www.google.com/maps/search/?api=1&query=${encodeURI(
                  schoolDistrict.details.address
                )}`"
              >
                {{ schoolDistrict.details.address }}
              </a>
            </td>
          </tr>
          <tr v-if="loading || schoolDistrict.details.numSchools">
            <th>Schools</th>
            <td v-if="loading">&nbsp;</td>
            <td v-else>
              {{ schoolDistrict.details.numSchools }}
              <a
                :href="`https://nces.ed.gov/ccd/schoolsearch/school_list.asp?Search=1&DistrictID=${schoolDistrict.id}`"
                target="_blank"
              >
                View all schools
              </a>
            </td>
          </tr>
        </table>
        <div class="stats">
          <div
            class="stat"
            v-if="loading || schoolDistrict.details.teacherStudentRatio !== '†'"
          >
            <div class="stat__value">
              {{
                loading ? "&nbsp;" : schoolDistrict.details.teacherStudentRatio
              }}
            </div>
            <div class="stat__label">Student/Teacher Ratio</div>
          </div>
          <div class="stat">
            <div class="stat__value">
              {{
                loading
                  ? "&nbsp;"
                  : `${schoolDistrict.demographics.BelowPoverty}%`
              }}
            </div>
            <div class="stat__label">Families Below the Poverty Line</div>
          </div>
          <div class="stat">
            <div class="stat__value">
              {{
                loading
                  ? "&nbsp;"
                  : `${schoolDistrict.demographics.FoodStamps}%`
              }}
            </div>
            <div class="stat__label">Families with Food benefits</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: {
    districts: {
      type: Array
    }
  },
  data() {
    return {
      schoolDistricts: [{ id: "loading", details: null, demographics: null }],
      loading: true
    };
  },
  compatConfig: { WATCH_ARRAY: false },
  methods: {
    async getSchoolDistrict(district) {
      const response = await axios.get(`/api/schoolDistrict?id=${district.id}`);
      return { ...district, ...response.data };
    },
    async getSchoolDistricts() {
      if (!this.districts) {
        return;
      }
      this.loading = true;
      this.schoolDistricts = [
        { id: "loading", details: null, demographics: null }
      ];
      try {
        this.schoolDistricts = await Promise.all(
          this.districts.map(d => this.getSchoolDistrict(d))
        );
      } catch {
        this.schoolDistricts = [];
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    districts: {
      handler() {
        this.getSchoolDistricts();
      },
      deep: true
    }
  },
  async created() {
    this.getSchoolDistricts();
  }
};
</script>
